export const bgColorBlack = '#111'
export const orangeColor = '#FFA53B'
export const whiteColor = 'white'
export const brandColor = '#3836B4'
export const brandColorImportant = '#8C52FF !important'